module.exports = __webpack_public_path__ + "img/5ac_20.3d78fcf9.gif";